import React from 'react'

const STSAdjustmentPartial = () => {
    return (
        <>
            <div>STS Adjustment Calculation</div>
        </>
    )
}

export default STSAdjustmentPartial